module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/mb-subaccount-30eff11c85b7c241a252b39a48dc413c.png";